import { gql } from "@apollo/client";

const INITIATE_WHATSAPP_CALL = gql`
  mutation initiateWhatsAppCall($inboxId: ID!, $sdpOffer: String!) {
    initiateWhatsAppCall(inboxId: $inboxId, sdpOffer: $sdpOffer) {
      id
      callId
      status
      sdpOffer
    }
  }
`;

export default INITIATE_WHATSAPP_CALL;
